import { Link } from 'react-router-dom';
import './Footer.scss';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="Footer">
      <div className="Footer-inner inner">
        <div className="Footer-top">
          <div className="Footer-brand">
            <span className="Footer-logoMark material-icons" aria-hidden>
              local_cafe
            </span>
            <div>
              <strong>카페앱모아</strong>
              <span>cafe app more</span>
            </div>
          </div>
          <nav className="Footer-links">
            <a href="#about">서비스 소개</a>
            <a href="#features">주요 기능</a>
            <a href="#flow">주문 흐름</a>
            <a href="#join">입점 안내</a>
            <a href="#contact">문의하기</a>
          </nav>
        </div>

        <ul className="Footer-info">
          <li>상호명: 카페앱모아</li>
          <li>고객센터: 1544-0000</li>
          <li>이메일: support@cafeappmoa.co.kr</li>
        </ul>

        <div className="Footer-bottom">
          <p className="Footer-copy">&copy; {year} Cafeappmore. All rights reserved.</p>
          <div className="Footer-admin">
            <Link to="/appmanage/login">매장 관리자</Link>
            <Link to="/admin/login">플랫폼 관리자</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
